import {getClassSessionQuery} from './get-class-session'

export const ClassSessionQueries = {getClassSessionQuery}
